import React, { useCallback } from 'react';
import { seoEnable } from 'reactApp/appHelpers/featuresHelpers/features/seoEnable';
import { useFeaturesEnabled } from 'reactApp/components/SharingWindow/hooks/useFeautresEnabled';
import type { EFrom, SendSharingContentAnalytics } from 'reactApp/components/SharingWindow/Sharing.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { gaSuffix } from 'reactApp/ui/EmptyFolder/EmptyFolder.types';
import { sendPaymentGa } from 'reactApp/utils/paymentGa';

import { AutoDelete } from '../SharingNew/Weblink/AutoDelete/AutoDelete';
import { ChangeDesign } from '../SharingNew/Weblink/ChangeDesign/ChangeDesign';
import { PublicPassword } from '../SharingNew/Weblink/PublicPassword/PublicPassword';
import { PaidFeaturesWrapper } from './PaidFeaturesWrapper';

export enum SharingWidnowContext {
    SHARRING = 'sharing',
    TAB = 'tab',
    ONBOARDING = 'onboarding',
}
interface PaidFeatureBlockProps {
    context: SharingWidnowContext;
    itemStorage?: EStorageType;
    isPhone?: boolean;
    isTabDesing?: boolean;
    from: EFrom;
    id: string;
}

export function PaidFeatureBlock({ context, itemStorage, isPhone, isTabDesing, from, id }: PaidFeatureBlockProps) {
    const {
        showAutoDeleteSettings,
        showChangeDesign,
        showChangePassword,
        item,
        isFolder,
        isAutodeleteFeatureEnabled,
        isAutodeletePromoFeatureEnabled,
        isWeblinkOpened,
    } = useFeaturesEnabled({ itemStorage, isPhone, from, id });
    const isOnboarding = context === SharingWidnowContext.ONBOARDING;
    const sendSharingContentAnalytics = useCallback<SendSharingContentAnalytics>(({ action, label }) => {
        sendPaymentGa({ eventCategory: 'enable-sharing', action, label });
    }, []);
    const onDropdownClick = useCallback(() => {
        sendSharingContentAnalytics({ action: 'auto-delete', label: 'click' });
    }, [sendSharingContentAnalytics]);

    return (
        <PaidFeaturesWrapper tooltipOuter={context === SharingWidnowContext.TAB} isOnboarding={isOnboarding} isFolder={isFolder}>
            {showChangeDesign && <ChangeDesign isOnboardingDesign isTabsDesign={isTabDesing} isOnboarding={isOnboarding} item={item} />}
            {/* tempexp_17605-next-line */}
            {showChangePassword && (
                <PublicPassword isOnboardingDesign isTabsDesign={isTabDesing} isOnboarding={isOnboarding} forcePromo={false} item={item} />
            )}
            {showAutoDeleteSettings && (
                <AutoDelete
                    isOnboardingDesign
                    isTabs={isTabDesing}
                    isOnboarding={isOnboarding}
                    item={item}
                    disabled={!isAutodeleteFeatureEnabled && isAutodeletePromoFeatureEnabled && isWeblinkOpened}
                    gaSuffix={gaSuffix}
                    onDropdownClick={onDropdownClick}
                    disabledBySeo={item?.weblinkSeoEnabled && seoEnable}
                />
            )}
        </PaidFeaturesWrapper>
    );
}
